import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import React, { useCallback } from 'react';

import translations from './.vocab';
import { useSupportedCountries } from './data';

interface LocationGroupSubtitleProps {
  countryCode: string;
}

export const useGetCountryTitle = () => {
  const { supportedCountries } = useSupportedCountries();
  const { t } = useTranslations(translations);

  const getCountryName = useCallback(
    (countryCode: string) =>
      supportedCountries.find(
        (supportedCountry) => supportedCountry.countryCode === countryCode,
      )?.name,
    [supportedCountries],
  );

  const getCountryTitle = useCallback(
    () => (countryCode: string) => getCountryName(countryCode) || t('Other'),
    [getCountryName, t],
  );

  return getCountryTitle();
};

export const LocationGroupSubtitle = ({
  countryCode,
}: LocationGroupSubtitleProps) => {
  const getCountryTitle = useGetCountryTitle();

  return (
    <Text tone="secondary" size="small" weight="strong">
      {getCountryTitle(countryCode)}
    </Text>
  );
};
